/*
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */
import React, { useEffect } from 'react';

export interface VideoPlayerProps {
  userId: string;
  setRemoteVideoPlayer?: (userId: string, domId: string | undefined) => void;
}

const MediaPlayer: React.FC<VideoPlayerProps> = ({ userId, setRemoteVideoPlayer }) => {
  useEffect(() => {
    if (!setRemoteVideoPlayer) return;
    setRemoteVideoPlayer(userId, `remoteStream_${userId}`);
    return () => {
      setRemoteVideoPlayer(userId, undefined);
    };
  }, [setRemoteVideoPlayer, userId]);

  return (
    <div
      style={{ width: '100%', height: '100%', position: 'relative', background: '#000' }}
      className="remoteStream"
      id={`remoteStream_${userId}`}
    >
      <span
        style={{
          color: 'rgba(255, 255, 255, 0.9)',
          position: 'absolute',
          bottom: '12px',
          left: '16px',
          zIndex: 1000,
          background: 'rgba(0, 0, 0, 0.45)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          padding: '4px 10px',
          borderRadius: '999px',
          fontSize: '12px',
          fontWeight: 500,
          maxWidth: '180px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {userId}
      </span>
    </div>
  );
};

export default MediaPlayer;
